import React, { useEffect, useRef, useState } from 'react';
import { OutsideClickHandler } from '../../../components';
import { createResourceLocatorString } from '../../../util/routes';
import css from '../AlgoliaSearchPage.module.css';
import { sendQuerySubmittedEvent } from '../../../analytics/AlgoliaEvents';
import { useSelector } from 'react-redux';
import { currentUserIdSelector } from '../../../ducks/user.duck';
import { parse } from '../../../util/urlHelpers';
import { PRIMARY_DESTINATIONS_FILTER, SECONDARY_DESTINATIONS_FILTER } from '../../../constants';
import IconCollection from '../../../components/IconCollection/IconCollection';
import axios from 'axios';
import { useLocation } from 'react-router-dom';

const AlgoliaSearchBar = ({ routeConfiguration, history, isTopbarSearch = false, isMobileTopbar }) => {
  const location = useLocation();
  const previousSearch = parse(location.search || '');
  // const previousSearch = parse(window?.location?.search || "");
  const {
    query
  } = previousSearch;
  const currentUserId = useSelector(currentUserIdSelector);

  const [destinations, setDestinations] = useState([]);
  const mapboxToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
  const [countryInput, setCountryInput] = useState(query);
  const [countryInputFocused, setCountryInputFocused] = useState(false);
  const countryDropdownRef = useRef(null);
  const showPredictions = countryInputFocused;
  const [predictions, setPredictions] = useState([]);

  const fetchPredictions = async query => {
    try {
      const response = await axios.get(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${query}.json?access_token=${mapboxToken}&types=country,region`
      );

      setPredictions(response.data.features.filter(prediction => !destinations.includes(prediction)));
    } catch (error) {
      console.error('Error fetching predictions:', error);
    }
  };

  useEffect(() => {
    if (countryInput) {
      fetchPredictions(countryInput);
    } else {
      setPredictions([]);
    }
  }, [countryInput, destinations]);


  const handlePredictionClick = prediction => {
    const { place_type: placeType, place_name, context, text } = prediction || {};
    const isRegion = placeType.find(elm => elm === 'region');
    const isCountry = placeType.find(elm => elm === 'country');
    sendQuerySubmittedEvent({ currentUserId, keyword: place_name });
    setCountryInput(place_name);
    // if selection is country
    if (isCountry) {
      delete previousSearch[SECONDARY_DESTINATIONS_FILTER];
      history.push(
        createResourceLocatorString('SearchPage', routeConfiguration, {}, {
          ...((isTopbarSearch || isMobileTopbar) ? {} : { ...previousSearch }),
          query: place_name,
          [PRIMARY_DESTINATIONS_FILTER]: place_name,
        })
      );
    }
    // if selection is region
    if (isRegion) {
      const toSearch = context.find(elm => elm.id.includes('country'))?.text;
      return history.push(
        createResourceLocatorString('SearchPage', routeConfiguration, {}, {
          ...((isTopbarSearch || isMobileTopbar) ? {} : { ...previousSearch }),
          query: place_name,
          [PRIMARY_DESTINATIONS_FILTER]: toSearch,
          [SECONDARY_DESTINATIONS_FILTER]: `${toSearch}_${text}`
        })
      );
    }
    setPredictions([]);
    setCountryInputFocused(false);
  };

  const handleInputChange = e => {
    setCountryInput(e.target.value)
    if (!e.target.value) {
      delete previousSearch?.["query"]
      delete previousSearch?.[PRIMARY_DESTINATIONS_FILTER]
      delete previousSearch?.[SECONDARY_DESTINATIONS_FILTER]
      history.push(
        createResourceLocatorString('SearchPage', routeConfiguration, {}, {
          ...((isTopbarSearch || isMobileTopbar) ? {} : { ...previousSearch }),
        })
      );
    }
  };

  const handleOnBlur = (e) => {
    if (!e.target.value) {
      delete previousSearch?.["query"]
      delete previousSearch?.[PRIMARY_DESTINATIONS_FILTER]
      delete previousSearch?.[SECONDARY_DESTINATIONS_FILTER]
      history.push(
        createResourceLocatorString('SearchPage', routeConfiguration, {}, {
          ...((isTopbarSearch || isMobileTopbar) ? {} : { ...previousSearch }),
        })
      );
    }
  };

  return (
    <OutsideClickHandler className={css.outsideRoot} onOutsideClick={() => setCountryInputFocused(false)}>
      <div className={isMobileTopbar ? css.mobileSearchFrom : isTopbarSearch ? css.topbarSearchFrom : css.locationSearchForm}>
        {isTopbarSearch ? <IconCollection icon="search-icon" /> : <IconCollection icon="worldIcon" />}
        <input
          id="location"
          name="location"
          type="text"
          autoComplete={'off'}
          className={css.mobileInputRoot}
          placeholder={'Destination (country)'}
          onFocus={() => setCountryInputFocused(true)}
          onChange={handleInputChange}
          onBlur={handleOnBlur}
          value={countryInput}
          closeonblur={'true'}
        />
        {predictions.length > 0 && showPredictions && (
          <ul className={css.dropdown} ref={countryDropdownRef}>
            {predictions.map((prediction, index) => (
              <li className={css.predictionItem} key={`${prediction.id}-${index}`} onClick={() => handlePredictionClick(prediction)}>
                {prediction.place_name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </OutsideClickHandler>
  );
};

export default AlgoliaSearchBar;
